(function () {
    'use strict';

    angular.module('app').component('habilTurnover', {
        templateUrl: '@/turnover/turnover.html',
        transclude: true,
        bindings: {
            firmInfo: '=',
        },
        controller: TurnoverController
    });

    TurnoverController.$inject = ['translationsService'];
    function TurnoverController(translationsService) {

        const $controller = this;

        $controller.$onInit = initialize;

        function initialize() {
            // Load translations + title
            translationsService.loadTranslations(t => { $controller.translations = t; });
        }
    }
})();